const RELEASE_ENVIRONMENT = 'release';
const BETA_ENVIRONMENT = 'beta';
const PROD_ENVIRONMENT = 'prod';
var ConsumerName;
(function (ConsumerName) {
    ConsumerName["Registration"] = "registration";
    ConsumerName["OrderPreview"] = "orderPreview";
})(ConsumerName || (ConsumerName = {}));

export { BETA_ENVIRONMENT, ConsumerName, PROD_ENVIRONMENT, RELEASE_ENVIRONMENT };
//# sourceMappingURL=common-types.js.map
